import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, inject, input, ViewChildren } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { faGripDotsVertical, faPlus, faTrashCan } from '@fortawesome/pro-regular-svg-icons';

import { BlockLoopCustomOption } from '@empathy/survey/base';

import { BlockLoopCustomOptionForm } from '../../../../../models/blocks/block-loop-custom-option-form.model';
import { reserveOptionId } from '../../../../../models/reserve-option-id.function';
import { TextEditorComponent } from '../../../../text-editor/text-editor.component';

@Component({
  selector: 'empathy-custom-options-form',
  templateUrl: 'custom-options-form.component.html',
  styleUrls: ['./custom-options-form.component.scss']
})
export class SourceOptionsFormComponent {
  @ViewChildren(TextEditorComponent) ckEditor: TextEditorComponent[];

  customOptions = input<FormArray>();
  randomized = input<FormControl>();
  lastOptionIndex = input.required<FormControl<number>>();

  faGripDotsVertical = faGripDotsVertical;
  faPlus = faPlus;
  faTrashCan = faTrashCan;
  justAddedOptionId: string;

  private cdr = inject(ChangeDetectorRef);

  onPaste(event: string[], pastedOnIndex: number): void {
    const currentOption = this.customOptions().at(pastedOnIndex);
    const isCurrentEmpty = !currentOption.get('text').value;

    event.forEach((text, index) => {
      if (index === 0 && isCurrentEmpty) {
        currentOption.get('text').setValue(text);
      } else {
        const insertIndex = pastedOnIndex + index + (isCurrentEmpty ? 0 : 1);
        const id = reserveOptionId(this.lastOptionIndex(), this.customOptions().value).id;
        const newOption = new BlockLoopCustomOptionForm({ id, text } as BlockLoopCustomOption);
        this.customOptions().insert(insertIndex, newOption.form);
      }
    });

    this.cdr.detectChanges();
  }

  onAddOption(isLastOption: boolean, index: number = null): void {
    if (!isLastOption) {
      const option = this.customOptions().value[index + 1];
      const editor: DecoupledEditor = this.ckEditor.find((ed) => ed.id === option.id).editorInstance;
      editor.editing.view.focus();
      return;
    }

    const newOption = new BlockLoopCustomOptionForm();
    const newOptionId = reserveOptionId(this.lastOptionIndex(), this.customOptions().value).id;
    newOption.form.get('id').setValue(newOptionId);
    this.justAddedOptionId = newOptionId;
    this.customOptions().push(newOption.form);

    this.cdr.detectChanges();
  }

  onRemoveAt(index: number): void {
    this.customOptions().removeAt(index);
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.customOptions().controls, event.previousIndex, event.currentIndex);
  }
}
